"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseClient = void 0;
const token_1 = require("@app/domain/token");
const axios_1 = __importDefault(require("axios"));
class BaseClient {
    constructor(baseUrl = "", tokenResolver = new token_1.Resolver()) {
        Object.defineProperty(this, "baseUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: baseUrl
        });
        Object.defineProperty(this, "tokenResolver", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: tokenResolver
        });
        Object.defineProperty(this, "axios", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.axios = axios_1.default.create({
            baseURL: this.getBaseUrl(),
            headers: {
                Authorization: `bearer ${this.getToken()}`,
                Accept: "application/ld+json",
                "Content-Type": "application/json",
            }
        });
    }
    getBaseUrl() {
        return this.baseUrl;
    }
    getToken() {
        return this.tokenResolver.getToken();
    }
}
exports.BaseClient = BaseClient;
